const persians = {
  state: "barbarian",
  name: "persians",
  canTransitionState: true,
};

const macedonians = {
  state: "barbarian",
  name: "macedonians",
  canTransitionState: true,
};

const greeks = {
  state: "barbarian",
  name: "greeks",
  canTransitionState: true,
};
const carthaginians = {
  state: "barbarian",
  name: "carthaginians",
  canTransitionState: true,
};

const celts = {
  state: "barbarian",
  name: "celts",
  canTransitionState: true,
};

const romans = {
  state: "barbarian",
  name: "romans",
  canTransitionState: true,
};

const scythians = {
  state: "barbarian",
  name: "scythians",
  canTransitionState: true,
};

const vikings = {
  state: "barbarian",
  name: "vikings",
  canTransitionState: false,
};

const arthurians = {
  state: "barbarian",
  name: "arthurians",
  canTransitionState: false,
};

const atlanteans = {
  state: "empire",
  name: "atlanteans",
  canTransitionState: false,
};

const egyptians = {
  state: "barbarian",
  name: "egyptians",
  canTransitionState: true,
};

const mauryans = {
  state: "barbarian",
  name: "mauryans",
  canTransitionState: true,
};

const minoans = {
  state: "barbarian",
  name: "minoans",
  canTransitionState: true,
};

const olmecs = {
  state: "barbarian",
  name: "olmecs",
  canTransitionState: true,
};

const qin = {
  state: "barbarian",
  name: "qin",
  canTransitionState: true,
};

const utopians = {
  state: "barbarian",
  name: "utopians",
  canTransitionState: false,
};

const nations = [
  arthurians,
  atlanteans,
  carthaginians,
  celts,
  egyptians,
  greeks,
  macedonians,
  mauryans,
  minoans,
  olmecs,
  persians,
  qin,
  romans,
  scythians,
  utopians,
  vikings,
];

for (let index = 0; index < nations.length; index++) {
  const nation = nations[index];
  try {
    nation.barbarianActions = require(`../public/${nation.name}-barbarian.png`);
  } catch (error) {
    // do nothing
  }

  try {
    nation.empireActions = require(`../public/${nation.name}-empire.png`);
  } catch (error) {
    // do nothing
  }
}
export default nations;
